import { createSelector } from 'reselect'

import {
  selectAgentsByIdIncludingArchived,
  selectAgentsByUsername,
} from 'selectors/agents/base'
import { selectGroupsById } from 'selectors/app'
import { selectCurrentUser } from 'ducks/currentUser/selectors/base'
import { selectCustomersById } from 'ducks/customers/selectors'
import { selectLabelsById } from 'selectors/labels/base'

import { mapObject, emptyObj } from 'util/objects'

import { decorate } from './shared/util'

import { selectTicketIdFromProps } from './props'

const selectById = state => {
  return state.tickets.byId || emptyObj
}

export const selectRawById = state => state.tickets.byId || emptyObj

// Our main ticket selector
export const selectTicketsById = createSelector(
  selectById,
  selectAgentsByIdIncludingArchived,
  selectGroupsById,
  selectCurrentUser,
  selectCustomersById,
  selectLabelsById,
  selectGroupsById,
  selectAgentsByUsername,
  (
    byId,
    agentsById,
    groupsById,
    currentUser,
    customersById,
    labelsById,
    groupsByName,
    agentsByUsername
  ) => {
    return mapObject(
      decorate(
        agentsById,
        groupsById,
        currentUser,
        customersById,
        labelsById,
        groupsByName,
        agentsByUsername
      )
    )(byId || emptyObj)
  }
)

export function selectTicket(state, id) {
  return selectTicketsById(state)[id] || emptyObj
}

export function selectRawTicket(state, id) {
  return selectRawById(state)[id] || emptyObj
}

export function makeSelectTicketById() {
  return createSelector(
    selectTicketsById,
    selectTicketIdFromProps,
    (ticketsById, ticketId) => {
      return ticketsById[ticketId] || emptyObj
    }
  )
}

export function makeSelectRawTicketById() {
  return createSelector(
    selectRawById,
    selectTicketIdFromProps,
    (ticketsById, ticketId) => {
      return ticketsById[ticketId] || emptyObj
    }
  )
}
